import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InputContainer = styled.div`
    padding: 10px;
    background-color: ${props => (props.valid ? 'inherit' : '#FFD9C7')};
    box-shadow: ${props => (!props.valid && props.submitting ? '0 0 0 1pt rgba(255, 0, 0, 0.7)' : '0 0 0 1pt #E3E5E8')};
    border-radius: 6px;
    width: 100%;
`;

const InputLabel = styled.label`
    display: block;
    margin: 5px 0;
    height: 20%;
    color: ${props => props.theme.inputLabels || '#373737'};
    font-weight: 600;
`;

export const StyledInput = styled.input`
    border: solid 1px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    font-size: ${props => props.fontSize || '12px'};
    height: ${props => props.height || '24px'};
    padding-left: 5px;
    flex: 1 1 100%;
    width: 98%;
`;

const TextArea = styled.textarea`
    border: solid 1px rgba(0, 0, 0, 0.3);
    border-radius: 5px;
    font-size: ${props => props.fontSize || '12px'};
    height: ${props => props.height || '24px'};
    padding-left: 5px;
    flex: 1 1 100%;
    width: 98%;
`;

const ErrorText = styled.div`
    color: ${props => props.theme.errorText};
    font-size: 12px;
    display: inline;
    opacity: ${props => (props.valid ? 0 : 1)};
    transition: opacity 0.4s;
`;

const TextInput = ({
    name,
    value,
    label,
    labelColor,
    height,
    width,
    margin,
    fontSize,
    valid,
    errorMessage,
    submitting,
    textArea,
    onChange,
    maxLength,
    className,
    type,
    onFocus,
    min
}) => {
    const inputProps = {
        name,
        value,
        onChange,
        fontSize,
        height,
        onFocus
    };

    const getValidation = () => {
        return !valid && <ErrorText valid={valid}>{errorMessage}</ErrorText>;
    };

    let inputBackground = 'background-color 0.4s';

    const transition = {
        transition: (inputBackground += submitting ? ', box-shadow 0.4s' : '')
    };

    return (
        <InputContainer column style={transition} valid={valid} submitting={submitting}>
            <InputLabel>{label}</InputLabel>
            {textArea ? (
                <TextArea
                    {...inputProps}
                    innerRef={input => {
                        this.textarea = input;
                    }}
                />
            ) : (
                <StyledInput
                    {...inputProps}
                    min={min}
                    innerRef={input => {
                        this.input = input;
                    }}
                    autoComplete="off"
                    maxLength={maxLength}
                    type={type}
                />
            )}
            {getValidation()}
        </InputContainer>
    );
};

TextInput.propTypes = {
    label: PropTypes.string.isRequired,
    labelColor: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    margin: PropTypes.string,
    fontSize: PropTypes.string,
    textArea: PropTypes.bool,
    valid: PropTypes.bool,
    errorMessage: PropTypes.string,
    submitting: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    type: PropTypes.string
};

TextInput.defaultProps = {
    label: '',
    labelColor: '#FFF',
    height: '40px',
    margin: '5px 0 0 0',
    fontSize: '18px',
    textArea: false,
    valid: true,
    errorMessage: '',
    submitting: false,
    maxLength: '',
    onChange: () => {},
    type: 'text'
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.js